import React from "react";
import { Route } from "react-router"; // react-router v4
import AdminTopPage from "src/container/admin/TopPage";
import AdminShopListPage from "src/container/admin/ShopListPage";
import AdminPushNotificationPage from "src/container/admin/PushNotificationPage";
import AdminPushNotificationReservedPage from "src/container/admin/PushNotificationReservedPage";
import ShopCreatePage from "src/container/admin/shop/ShopCreatePage";
import BakedBreadTagIndexPage from "src/container/admin/baked_bread_tags/BakedBreadTagIndexPage";
import HashtagListPage from "src/container/admin/master/HashtagListPage";
import HashtagCreatePage from "src/container/admin/master/HashtagCreatePage";
import HashtagEditPage from "src/container/admin/master/HashtagEditPage";

export const AdminRoutes = (props: any) => [
  <Route
    exact
    path="/admin"
    key={"AdminTopPage"}
    render={() => <AdminTopPage {...props} />}
  />,
  <Route
    exact
    path="/admin/shop"
    key={"AdminShopListPage"}
    render={() => <AdminShopListPage {...props} />}
  />,
  <Route
    exact
    path="/admin/pushnotifcation"
    key={"AdminPushNotificationPage"}
    render={() => <AdminPushNotificationPage {...props} />}
  />,
  <Route
    exact
    path="/admin/pushnotifcation/complete"
    key={"AdminPushNotificationReservedPage"}
    render={() => <AdminPushNotificationReservedPage {...props} />}
  />,
  <Route
    exact
    path="/admin/baked_bread_tags"
    key={"BakedBreadTagIndexPage"}
    render={() => <BakedBreadTagIndexPage {...props} />}
  />,
  <Route
    exact
    path="/admin/shop/create"
    key={"ShopCreatePage"}
    render={() => <ShopCreatePage {...props} />}
  />,
  <Route
    exact
    path="/admin/master/tags"
    key={"HashtagListPage"}
    render={() => <HashtagListPage {...props} />}
  />,
  <Route
    exact
    path="/admin/master/tags/create"
    key={"HashtagCreatePage"}
    render={() => <HashtagCreatePage {...props} />}
  />,
  <Route
    exact
    path="/admin/master/tags/edit/:id"
    key={"HashtagEditPage"}
    render={({ match }) => <HashtagEditPage id={match.params.id} {...props} />}
  />,
  // <Route exact path={"/error"} render={() => <ErrorPage {...props} />} />,
];
